// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","title":"Navbar_title__375uB","links":"Navbar_links__CwCbO","link":"Navbar_link__zGYRb"};